import {Injectable}                              from '@angular/core';
import {Store}                                   from '../index';
import {IStateStore}                             from '../../ap-interface';
import {ApSignalrService}                        from '../../ap-core/services/ap-signalr.service';
import {
  ClientStatusCheck,
  ClientStatusCheckSuccess
} from '../../../../projects/invoker-transport/src/lib/actions/administration';
import IClientStatus = Data.Client.IClientStatus;

export class ClientStatusState implements IStateStore<void> {
  data: [];
  loaded: boolean;
  loading: boolean;
  status: IClientStatus;
}

@Injectable({providedIn: 'root'})
export class ClientStatusStore extends Store<ClientStatusState> {
  constructor(public backend: ApSignalrService) {
    super(backend, {
        loaded: false,
        loading: false,
        data: [],
        status : undefined
      });

    backend.registerObservable(ClientStatusCheckSuccess).subscribe(d => {
      super.Mutate(s => s.status, () => d.Data);
    });
    this.DispatchBackend(new ClientStatusCheck());
  }
}
